<div class="login-page">
  <div class="login-card">
    <div class="login-header">
      <h1>Login</h1>
      <p class="welcome-text">Hi, Welcome back 👋</p>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">

      <div class="form-group">
        <label for="email">Email</label>
        <input type="email" id="email" formControlName="email" placeholder="E.g. johndoe@email.com"
          [class.error]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
        @if (loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
          <span class="error-msg">
            Please enter a valid email.
          </span>
        }
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <div class="password-wrapper">
          <input [type]="showPassword ? 'text' : 'password'" id="password" formControlName="password"
            placeholder="Enter your password"
            [class.error]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
          <button type="button" class="toggle-password" (click)="togglePassword()"
            aria-label="Toggle password visibility">
            <hugeicons-icon [icon]="showPassword ? viewOffIcon : viewIcon" [size]="20" color="currentColor"></hugeicons-icon>
          </button>
        </div>
      </div>

      <div class="form-actions">
        <label class="checkbox-container">
          <input type="checkbox" formControlName="rememberMe">
          <span class="checkmark"></span>
          Remember Me
        </label>
        <a routerLink="/auth/forgot-password" class="forgot-link">Forgot Password?</a>
      </div>

      <button type="submit" class="btn-login" [disabled]="isLoading">
        @if (!isLoading) {
          <span>Login</span>
        }
        @if (isLoading) {
          <span class="loading-content">
            <svg class="spinner" width="16" height="16" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none"
              opacity="0.25"></circle>
              <path fill="currentColor" d="M12 2a10 10 0 0 1 10 10h-4a6 6 0 0 0-6-6V2z" opacity="0.75"></path>
            </svg>
            Logging in...
          </span>
        }
      </button>
    </form>
  </div>
</div>